import Icon from "@ant-design/icons";
import React from "react";

export default function SaveIcon() {
  return <Icon className="ac-icon" component={IconSvg} />;
}

const IconSvg = () => {
  return (
    <svg height="1em" viewBox="0 0 24 24" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4 6.75C4 5.23122 5.23122 4 6.75 4H14.1716C14.9009 4 15.6004 4.28974 16.1161 4.80545L16.1161 4.80546L19.1945 7.88387C19.7103 8.39961 20 9.09908 20 9.82843V17.25C20 18.7688 18.7688 20 17.25 20H6.75C5.23122 20 4 18.7688 4 17.25V6.75ZM6.75 5.5C6.05964 5.5 5.5 6.05964 5.5 6.75V17.25C5.5 17.9404 6.05964 18.5 6.75 18.5H8V15.75C8 14.7835 8.78352 14 9.75 14H14.25C15.2165 14 16 14.7835 16 15.75V18.5H17.25C17.9404 18.5 18.5 17.9404 18.5 17.25V9.82843C18.5 9.4969 18.3683 9.17897 18.1339 8.94455L18.1339 8.94454L15.0555 5.86613C14.821 5.63168 14.5031 5.5 14.1716 5.5H9.5V8.25C9.5 8.66421 9.16421 9 8.75 9C8.33579 9 8 8.66421 8 8.25V5.5H6.75ZM14.5 18.5H9.5V15.75C9.5 15.6119 9.61192 15.5 9.75 15.5H14.25C14.3881 15.5 14.5 15.6119 14.5 15.75V18.5Z"
        fill="currentColor"
      />
    </svg>
  );
};
